import createViewComponent from '../../support/rn-web/createViewComponent';

export const View = createViewComponent({
  tagName: 'div',
  additionalProps: {
    className: true,
  },
});
